import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
const PieChart = ({ type = "pie", data }) => {
  const [chartData, setChartData] = useState();
  useEffect(() => {
    if (data) {
      const categories = data.map((item) => item.title);
      const values = data.map((item) => parseInt(item.value || 0));
      //   polarArea,donut,pie
      setChartData({
        series: values.map((value) => Math.abs(value)),
        options: {
          chart: { 
            type: type,
            fontFamily: 'Poppins, Inter, sans-serif',
            toolbar: { show: false }
          },
          colors: ['#3B82F6', '#10B981', '#6366F1', '#F59E0B', '#8B5CF6', '#EC4899', '#14B8A6', '#F43F5E'],
          labels: categories,
          stroke: {
            show: true,
            width: 2,
            colors: ['#ffffff']
          },
          legend: {
            position: 'bottom',
            fontSize: '12px',
            fontWeight: 500,
            labels: {
              colors: '#475569'
            },
            markers: {
              radius: 12,
              width: 10,
              height: 10
            },
            itemMargin: {
              horizontal: 10,
              vertical: 5
            }
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '11px',
              fontWeight: '600',
              colors: ['#ffffff']
            },
            dropShadow: {
              enabled: false
            }
          },
          tooltip: {
            theme: 'light',
            y: { formatter: (value) => value.toLocaleString() },
          },
          plotOptions: {
            pie: {
              donut: {
                size: '70%'
              }
            }
          }
        },
      });
    }
  }, [data, type]);

  if (!chartData) {
    return (
      <div>
        <h2>No Data</h2>
      </div>
    );
  }
  return (
    <div>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type={type}
        height={350}
      />
    </div>
  );
};

export default PieChart;
